import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';

export default function OrganiserLinePlot({
    data,
    width = '100%',   // Set default width to 100% for responsiveness
    height = 400,     // Fixed height to maintain aspect ratio
    marginTop = 20,
    marginRight = 20,
    marginBottom = 50,
    marginLeft = 50
}) {
    const svgRef = useRef();

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // Clear previous content

        // Convert height from pixels to centimeters
        const heightInCm = height / 37.7953;
        const conversionFactor = 10; // 1cm in the SVG = 10cm in your data
        const yMaxValue = heightInCm * conversionFactor; // Maximum value based on 10 units per cm

        // Generate the months array
        const now = new Date();
        const months = Array.from({ length: data.length }, (_, i) => {
            const date = new Date(now);
            date.setMonth(date.getMonth() - i);
            return date;
        }).reverse();

        const x = d3.scaleTime()
            .domain([months[0], months[months.length - 1]])
            .range([marginLeft, svg.node().clientWidth - marginRight]);

        const y = d3.scaleLinear()
            .domain([0, yMaxValue])
            .range([height - marginBottom, marginTop]);

        const xAxis = d3.axisBottom(x).ticks(data.length).tickFormat(d3.timeFormat("%b %Y"));
        const yAxis = d3.axisLeft(y).ticks(heightInCm);

        const line = d3.line()
            .x((d, i) => x(months[i]))
            .y(d => y(d / conversionFactor));

        // Append x-axis grid lines
        svg.append("g")
            .attr("class", "grid")
            .attr("transform", `translate(0,${height - marginBottom})`)
            .call(d3.axisBottom(x).ticks(data.length).tickSize(-height + marginTop + marginBottom).tickFormat(""))
            .selectAll("line")
            .attr("stroke", (d, i, nodes) => i === nodes.length - 1 ? "none" : "#CCCCCC"); // Hide the last grid line

        // Append y-axis grid lines
        svg.append("g")
            .attr("class", "grid")
            .attr("transform", `translate(${marginLeft},0)`)
            .call(d3.axisLeft(y).ticks(heightInCm).tickSize(-svg.node().clientWidth + marginLeft + marginRight).tickFormat(""))
            .selectAll("line")
            .attr("stroke", (d, i, nodes) => i === nodes.length - 1 ? "none" : "#CCCCCC"); // Hide the last grid line

        svg.append("g")
            .attr("transform", `translate(0,${height - marginBottom})`)
            .call(xAxis);

        svg.append("g")
            .attr("transform", `translate(${marginLeft},0)`)
            .call(yAxis);

        svg.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", "#5383ec") // Set plot line color to sky blue
            .attr("stroke-width", 1.5)
            .attr("d", line);

    }, [data, height, marginBottom, marginLeft, marginRight, marginTop, width]);

    return (
        <svg
            ref={svgRef}
            width={width}
            height={height}
            viewBox={`0 0 ${width === '100%' ? 640 : width} ${height}`} // Dynamic viewBox
            style={{ maxWidth: '100%', height: 'auto' }} // Ensure responsiveness
        ></svg>
    );
}
